import { render, staticRenderFns } from "./NewLayout.vue?vue&type=template&id=27bd06ce&scoped=true"
import script from "./NewLayout.vue?vue&type=script&lang=js"
export * from "./NewLayout.vue?vue&type=script&lang=js"
import style0 from "./NewLayout.vue?vue&type=style&index=0&id=27bd06ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bd06ce",
  null
  
)

export default component.exports